import {defineStore} from 'pinia'

// @ts-ignore
export const useCommonStore = defineStore('common', {
  state: () => ({
    pathPrefix: '/common'
  }),
  getters: {},
  actions: {
    /**
     * 메인 랜딩페이지 데이터 조회
     * @param payload
     * @returns {Promise<*>}
     */
    async getMainLanding(payload) {
      const {$apiClient} = useNuxtApp()
      let query = ''
      if (payload) {
        query = `?year=${payload}`
      }
      const path = `${this.pathPrefix}/main${query}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    /**
     * 메인 페이지 검색
     * @param payload
     * @returns {Promise<*>}
     */
    async getSearchList(payload) {
      const {$apiClient} = useNuxtApp()
      const query = `?type=${payload.type}&page=${payload.page}&limit=${payload.limit}&keyword=${payload.keyword}`
      const path = `${this.pathPrefix}/search${query}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },

    async getNoticeList(payload) {
      const {$apiClient} = useNuxtApp()
      const query = `?page=${payload.page}&limit=${payload.limit}&keyword=${payload.keyword}`
      const path = `${this.pathPrefix}/notice${query}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    async postQna(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/qna`
      return await $apiClient(path, {
        method: 'POST',
        body: payload
      })
    },
    async postQnaFileUpload(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/pre-sign/qna/${payload.qnaId}`
      return await $apiClient(path, {
        method: 'POST',
        body: payload
      })
    },
    async postPartnership(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/partnership`
      return await $apiClient(path, {
        method: 'POST',
        body: payload
      })
    },
    async getQnaList(payload) {
      const {$apiClient} = useNuxtApp()
      const query = `?page=${payload.page}&limit=${payload.limit}&keyword=${payload.keyword}`
      const path = `${this.pathPrefix}/qna${query}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },

    async getPartnershipBoardList(payload) {
      const {$apiClient} = useNuxtApp()
      const query = `?page=${payload.page}&limit=${payload.limit}`
      const path = `${this.pathPrefix}/partnership${query}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },

    async getPartnershipBoardDetail(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/partnership/${payload}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },

    async getQnaDetail(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/qna/${payload}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },

    async postQnaReply(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/qna/reply/${payload.qnaId}`
      return await $apiClient(path, {
        method: 'POST',
        body: payload
      })
    },

    async getFaqList(payload) {
      const {$apiClient} = useNuxtApp()
      const query = `?type=${payload}`
      const path = `${this.pathPrefix}/faq${query}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    /**
     * KPI 사업안내 조회
     * @returns {Promise<void>}
     */
    async getBusinessInfo() {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/business-info`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    /**
     * 이용약관 관련 정보 조회
     * @param type
     * @returns {Promise<void>}
     */
    async getTermsInfo(type) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/terms`
      const query = `?type=${type}`
      return await $apiClient(`${path}${query}`, {
        method: 'GET'
      })
    },
    /**
     * 에디터 작성글 조회
     * @param payload
     * @returns {Promise<void>}
     */
    async getEditorBoard(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/editor`
      const query = `?parentType=${payload.parentType}&type=${payload.type}`
      return await $apiClient(`${path}${query}`, {
        method: 'GET'
      })
    }
  }
})
